// @flow

import React, { Component } from 'react'
import { Layout, ImageHeader, Caption, BodyTitle, Logo } from './Sections'
import Pdf from './Sections/PDF'
import NewPDF from './Sections/NewPDF'
import axios from 'axios'

import Icon from 'michelangelo/dist/Components/Icon'

import styled from 'styled-components'
import type { ReactComponentStyled } from 'styled-components'

const SaveButtonContainer: ReactComponentStyled<{}> = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-right: calc(1% + 10px);
`

const SaveButtonText: ReactComponentStyled<{}> = styled.span`
  margin-left: 6px;
`

const SaveButton: ReactComponentStyled<{}> = styled.p`
  text-decoration: none;
  padding: 8px 12px;
  color: black;
  font-family: Raleway;
  font-weight: 300;
  cursor: pointer;
`

type PDFContentProps = {
  title: string,
  logoUrl: string,
  caption: ?string,
  fileUrl: string,
  pdfS3Key: ?string,
  thumbnail: ?string,
  hashtags: string[]
}

class PDFContent extends Component <PDFContentProps, {}> {
  getHeader () {
    const { thumbnail } = this.props
    if (thumbnail) {
      return <ImageHeader src={thumbnail} sideNav />
    }

    return null
  }

  async handleClick (file, title) {
    const handleFileDownload = async (link, title) => {
      const response = await axios.get(link, { responseType: 'blob' })
      const responseUrl = response.config.url
      const extension = responseUrl.split('.').pop().split(/\#|\?/)[0]
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const a = document.createElement('a')
      a.href = url
      a.setAttribute('download', `${title}.${extension}`)
      const body = document.body
      if (body) body.appendChild(a)
      a.click()
      a.remove()
    }

    handleFileDownload(file, title)
  }

  getBody () {
    const { logoUrl, fileUrl, pdfS3Key, title: contentTitle } = this.props
    const title = this.getBodyTitle()
    const caption = this.getCaption()
    const pdf = this.getPDFContainer()
    return (
      <div>
        <Logo src={logoUrl} />
        {title}
        {caption}
        <SaveButtonContainer>
          <SaveButton onClick={() => this.handleClick(fileUrl, contentTitle)}>
            <Icon color={'black'} iconName='download'/>
            <SaveButtonText>
              Download Original
            </SaveButtonText>
          </SaveButton>
          { pdfS3Key &&
            <SaveButton onClick={() => this.handleClick(pdfS3Key, contentTitle)}>
              <Icon color={'black'} iconName='download'/>
              <SaveButtonText>
                Download PDF
              </SaveButtonText>
            </SaveButton>
          }
        </SaveButtonContainer>
        {pdf}
      </div>
    )
  }

  getCaption () {
    const { caption, logoUrl, hashtags } = this.props
    if (!caption) {
      return null
    }
    return <Caption usePadding={!logoUrl} caption={caption} hashtags={hashtags} />
  }

  getBodyTitle () {
    const { title } = this.props
    return <BodyTitle title={title} usePadding={false} />
  }

  getPDFContainer () {
    const { fileUrl, pdfS3Key } = this.props
    if (pdfS3Key) {
      return <NewPDF url={pdfS3Key} />
    }
    return <Pdf url={fileUrl} />
  }

  render () {
    const { logoUrl } = this.props
    const header = this.getHeader()
    const body = this.getBody()
    return (
      <Layout header={header} body={body} usePadding={!logoUrl} useParallax={header} />
    )
  }
}

export default PDFContent
